module.exports = __webpack_public_path__ + "img/icon-libra@3x.c0fc5777.png";